import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import ThemeConsumer from "shared/components/ThemeConsumer"

const ContainerGradient = ({
  theme,
  children,
  classNames,
  atPosition = "X",
  color = "default"
}) => {
  const containerClasses = classnames(
    theme[`${atPosition}-${color}`],
    classNames
  )

  return <section className={containerClasses}>{children}</section>
}

ContainerGradient.propTypes = {
  theme: PropTypes.shape({
    container: PropTypes.string
  }),
  classNames: PropTypes.string,
  children: PropTypes.node.isRequired,
  atPosition: PropTypes.oneOf(["X", "Y", "D"]),
  color: PropTypes.string
}

export default ThemeConsumer("UIContainerGradient")(ContainerGradient)



// WEBPACK FOOTER //
// ./src/components/ContainerGradient/index.js